// src/constants/editionColors.ts
// 版ごとのブランドカラー（/editions ページの CARD_DOT_COLORS と同じ値）。
// 軌跡マップで、意味座標を持たない非logical版の点色として使う。

import type { CardType } from "@/types/Plan";

export const EDITION_DOT_COLORS: Partial<Record<CardType, string>> = {
  standard:     "rgb(252,227,0)",
  logical:      "rgb(1,174,214)",
  storytelling: "rgb(1,193,160)",
  life:         "rgb(224,82,62)",
  emotion:      "rgb(244,155,187)",
};
